export interface RangeConfig {
  range: number;
  nearShopsCount: number;
}

export const rangeConfig: RangeConfig = {
  range: 50000,
  nearShopsCount: 25
};
